import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

interface CollectionHeroAttrs {
    className?: string
}

export class CollectionHero extends MithrilComponent<CollectionHeroAttrs> {
    view(vnode: m.Vnode<CollectionHeroAttrs>) {
        return <div className={classes('c-collection-hero', vnode.attrs.className)}>{vnode.children}</div>
    }
}
